import React , { useState ,  useContext , useEffect} from 'react'
import { AppContext } from '../context/AppContext';
import {   db , setDoc , doc  , collection , getDocs , deleteDoc  } from '../firebase';

const LocationSlideSix = (   ) => {

    const [nextTo , setNextTo ] = useState(false);
    const [priceValue , setPriceValue ] = useState(0);
    const [cartItems , setCartItems ] = useState([]);

    const user = JSON.parse(localStorage.getItem("tourst_compass_user"));
    const [ clientName , setClientName ] = useState('');
    const [ clientPhoneNumber , setClientPhoneNumber ] = useState('');
    const [ mapRating , setMapRating ] = useState('');
    const [ serviceRating , setServiceRating ] = useState('');
    const [loading , setLoading] = useState(false);
    const [error , setError] = useState('');
    const [success , setSuccess ] = useState(false);

    const totalPrice = (array) => {
      const prices = array.map((item) => parseInt(item.price));
      let totalValue  = prices.reduce((a, b) => a + b);
      setPriceValue(totalValue);
    };

    useEffect(() => {

      const getUsersOrders = async () => { 
        const querySnapshot = await getDocs(collection(db, `cart ${user.id}` ));
        const ordersDataArray = querySnapshot.docs
        .map((doc) => ({ ...doc.data(), id: doc.id }));
  
        totalPrice(ordersDataArray);
  
        setCartItems(ordersDataArray);
    
       
      }
      getUsersOrders();
  
  
  } , [cartItems]);


  const {slideIndex} = useContext(AppContext);
  const [ indexSlideValue , setIndexSlideValue ] = slideIndex;

  const {location} = useContext(AppContext);

  const [ locationValue  ] = location;


  const makeid = (length) =>  {
    var result           = '';
    var characters       = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    var charactersLength = characters.length;
    for ( var i = 0; i < length; i++ ) {
      result += characters.charAt(Math.floor(Math.random() * 
 charactersLength));
   }
   return result;
}


  const submitOrder = async (e) => {
    e.preventDefault();

    setLoading(true);

if (clientName === ''  ) {
  setError(' يرجى ادخال اسم مقدم للطلب ');
}

if (clientPhoneNumber === ''  ) {
  setError(' يرجى ادخال رقم هاتف مقدم للطلب ');
}

setTimeout(() => {
  setLoading(false);
  setError('');
} , 2500)

    if (clientName !== '' && clientPhoneNumber !== '' ) {

      let idMaked = makeid(20);
      
        const orders = await setDoc(doc(db, "orders", idMaked ), {

          name: clientName,
          phone_number: clientPhoneNumber,
          map_rating: mapRating,
          service_rating: serviceRating,
          orders: cartItems,
          package_name: locationValue,
          totalPrice: priceValue
          
         
          });

        
        
            setSuccess(true);
            setLoading(false);
            setError('');

            setTimeout(() => {
                setSuccess('');
              
                let number = '+966501057512';

                let message = ` 
                مرحبا أود تاكيد حجزي عن طريق البوصلة السياحية باسم ${clientName}
                وكود حجزي هو ${idMaked}`;

                      // Appending the phone number to the URL
          let url = `https://web.whatsapp.com/send?phone=${number}`;

          // Appending the message to the URL by encoding it
          url += `&text=${encodeURI(message)}&app_absent=0`;

          // Open our newly created URL in a new tab to send the message
          window.open(url);
            } , 1350);

         

    }

  }
  const removeCartFromDb = async (id) => { 
 
    await deleteDoc(doc(db, `cart ${user.id}`, id ));
  
  }
  

  return (
    <div className="main_slide_two">

    <div className='container-sm' >

      <div className="text-center top_area_slide_two">
        <img src="/images/icons/logo.png" alt="" className="icon_big" />
        <h1 className="location_slidetwo_headline"> البوصلة السياحية</h1>
      </div>

      {cartItems.length != 0 ? (
        <div className="grid_invoice_section mt-5">
        <h1 className="location_slidetwo_headline border_b">  السعر </h1>
        <h1 className="location_slidetwo_headline border_b">اسم المنتج</h1>
      
      </div>
      ) : ''}
     

      <div className="grid_invoice_section mt-2">

      {cartItems.length != 0 ? cartItems.map(( { id , name , price , service_provider } ) => (
        <>
        <p className="main_para">   SAR {price}   </p>
      <p className="main_para"> حجز {service_provider} - {name}  - <br />  <button  className="mt-1 btn_pricing mx-2 bg_red w-30" onClick={() => removeCartFromDb(id ) }  > ❌ الغاء   </button>   </p>
     
        </>

      )) : ''}
      
     

     

      
      </div>

      {error && (
                            <>
                            <h1 className="mb-1 error_headline"> {error} </h1>
                            </>
                        )}

                {success && (
                    <>
                        <div className="popup_success">
                            <img src="/images/icons/check.png" alt="" />
                        </div>
                    </>
                )}

      {cartItems.length == 0 && (
        <p className="main_para"> لم تقم بطلب شئ حتى الان , يمكنك تصفح بكجاتنا واختيار منتج </p>
      ) }
      <div className="text-right my-3">
    
      <p className="main_para">المجموع كامل : {priceValue} ريال</p>
      </div>

     

      { cartItems.length !== 0 ? nextTo ? (

        <form onSubmit={submitOrder} >
        
      <div className="input_form_div">
          <label htmlFor="" className="login_label_form">اسم مقدم الطلب</label>
          <input value={clientName} onChange={(e) => setClientName(e.target.value) } type="text" className="login_input_form " placeholder='يرجى كتابة اسمك كمقدم للطلب' />
        </div>

      <div className="input_form_div">
          <label htmlFor="" className="login_label_form">رقم هاتف مقدم الطلب</label>
          <input value={clientPhoneNumber} onChange={(e) => setClientPhoneNumber(e.target.value) } type="number" placeholder='055 498 4459' className="login_input_form " />
        </div>

        <div className="input_form_div">
          <label htmlFor="" className="login_label_form"> تقييمك للخريطة الخاصة بنا ؟</label>
          <input value={mapRating} onChange={(e) => setMapRating(e.target.value) } type="text" className="login_input_form " placeholder='عطنا تقييم لخريطتنا وكيف ممكن نحسنها ؟' style={{ height: '5rem' }} />
        </div>

        <div className="input_form_div">
          <label htmlFor="" className="login_label_form">  عطنا اي ملاحظات لتحسين خدماتنا ؟ </label>
          <input value={serviceRating} onChange={(e) => setServiceRating(e.target.value) } type="text" className="login_input_form " placeholder='عطنا اي ملاحظات لتحسين خدماتنا' style={{ height: '5rem' }} />
        </div>

        <div className='input_form_div' >

        {loading ? (
              <>
                                <img src="/images/icons/loading-spinner.gif" className='loading_spinner' alt="" />
                            </>
            ) : (
              <button type='submit' className="mt-2 btn_login w-30">   تقديم الطلب </button>
            )}

        
        </div>

       
      </form>
      ) : (
        <div className="text-center btn_pay mt-3" onClick={() => setNextTo(!nextTo) } >المتابعة الان</div>
      ) : ''}
     

       


    </div>

    <div className="f-sv d-flex-c sliding_btns mt-3">
              <button className="btn_category bg_red " onClick={() => setIndexSlideValue(indexSlideValue - 1) } > السابق </button>

              </div>
      


    </div>
  )
}

export default LocationSlideSix